import { render, staticRenderFns } from "./CapacidadPago.vue?vue&type=template&id=5c86d212&scoped=true"
import script from "./CapacidadPago.vue?vue&type=script&lang=js"
export * from "./CapacidadPago.vue?vue&type=script&lang=js"
import style0 from "./CapacidadPago.vue?vue&type=style&index=0&id=5c86d212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c86d212",
  null
  
)

export default component.exports